// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableHeaderRow--rXqIq {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.comparisonTableHeader--yUh9s {
  font-family: var(--base-font);
  font-weight: 300;
  font-size: 15px;
  color: #000;
  height: 45px;
  position: relative;
}

[dir] .comparisonTableHeader--yUh9s {
  background: #ececec;
  padding: 5px 10px;
}

.firstHeaderCell--oc8AT {
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  width: 60%;
}

[dir] .firstHeaderCell--oc8AT {
  background: #333;
}

[dir=ltr] .firstHeaderCell--oc8AT {
  padding-left: 15px;
  text-align: left;
}

[dir=rtl] .firstHeaderCell--oc8AT {
  padding-right: 15px;
  text-align: right;
}

.measureIcon--VC3yH {
  display: inline-block;
  width: 20px;
  height: 20px;
}

[dir=ltr] .measureIcon--VC3yH {
  margin-right: 5px;
}

[dir=rtl] .measureIcon--VC3yH {
  margin-left: 5px;
}

.rowTitle--s7Tez {
  display: inline;
  vertical-align: top;
  color: #000;
}

[dir] .cell--HNgrN {
  padding: 3px;
}

@media (min-width: 450px) {
  [dir] .cell--HNgrN {
    padding: 5px 10px;
  }
}

[dir] .tblComparison--ufMMv th {
  border: 1px solid rgba(184, 184, 184, 0.3);
}

[dir] .tblComparison--ufMMv td {
  border: 1px solid rgba(184, 184, 184, 0.3);
}

@media (max-width: 450px) {
  .tblComparison--ufMMv th,
  .tblComparison--ufMMv td,
  .tblComparison--ufMMv td h4 {
    font-size: 12px;
  }
}

@media (max-width: 767px) {
  .tblComparison--ufMMv th,
  .tblComparison--ufMMv td,
  .tblComparison--ufMMv td h4 {
    font-size: 14px;
  }
}

[dir=ltr] .changeIcon--cc9Nx {
  float: right;
}

[dir=rtl] .changeIcon--cc9Nx {
  float: left;
}

.positiveChange--PNwzf {
  color: #657a2a;
}
.negativeChange--adyfV {
  color: #df1b12;
}

.verticalLine--THTSr {
  width: 5px;
  height: 22px;
}

[dir=ltr] .verticalLine--THTSr {
  margin-right: 2px;
  float: right;
}

[dir=rtl] .verticalLine--THTSr {
  margin-left: 2px;
  float: left;
}

[dir] .greenLine--uXkOm {
  background-color: #657a2a;
}

[dir] .redLine--zEOrT {
  background-color: #df1b12;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/DriversOfChangeDataTable/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,WAAW;EAGX,YAAY;EACZ,kBAAkB;AACpB;;AATA;EAKE,mBAAmB;EACnB,iBAAiB;AAGnB;;AAEA;EAEE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAEhB,UAAU;AAEZ;;AARA;EACE,gBAAgB;AAOlB;;AARA;EAKE,kBAAkB;EAElB,gBAAgB;AAClB;;AARA;EAKE,mBAAkB;EAElB,iBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AAEd;;AALA;EAIE,iBAAiB;AACnB;;AALA;EAIE,gBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;AACd;;AAFA;EACE,WAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;AAGd;;AALA;EAGE,iBAAiB;EACjB,YAAY;AACd;;AALA;EAGE,gBAAiB;EACjB,WAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".tableHeaderRow {\n  user-select: none;\n}\n\n.comparisonTableHeader {\n  font-family: var(--base-font);\n  font-weight: 300;\n  font-size: 15px;\n  color: #000;\n  background: #ececec;\n  padding: 5px 10px;\n  height: 45px;\n  position: relative;\n}\n\n.firstHeaderCell {\n  background: #333;\n  color: #fff;\n  text-transform: uppercase;\n  font-weight: 600;\n  padding-left: 15px;\n  width: 60%;\n  text-align: left;\n}\n\n.measureIcon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n}\n\n.rowTitle {\n  display: inline;\n  vertical-align: top;\n  color: #000;\n}\n\n.cell {\n  padding: 3px;\n}\n\n@media (min-width: 450px) {\n  .cell {\n    padding: 5px 10px;\n  }\n}\n\n.tblComparison th {\n  border: 1px solid rgba(184, 184, 184, 0.3);\n}\n\n.tblComparison td {\n  border: 1px solid rgba(184, 184, 184, 0.3);\n}\n\n@media (max-width: 450px) {\n  .tblComparison th,\n  .tblComparison td,\n  .tblComparison td h4 {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 767px) {\n  .tblComparison th,\n  .tblComparison td,\n  .tblComparison td h4 {\n    font-size: 14px;\n  }\n}\n\n.changeIcon {\n  float: right;\n}\n\n.positiveChange {\n  color: #657a2a;\n}\n.negativeChange {\n  color: #df1b12;\n}\n\n.verticalLine {\n  width: 5px;\n  height: 22px;\n  margin-right: 2px;\n  float: right;\n}\n\n.greenLine {\n  background-color: #657a2a;\n}\n\n.redLine {\n  background-color: #df1b12;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHeaderRow": `tableHeaderRow--rXqIq`,
	"comparisonTableHeader": `comparisonTableHeader--yUh9s`,
	"firstHeaderCell": `firstHeaderCell--oc8AT`,
	"measureIcon": `measureIcon--VC3yH`,
	"rowTitle": `rowTitle--s7Tez`,
	"cell": `cell--HNgrN`,
	"tblComparison": `tblComparison--ufMMv`,
	"changeIcon": `changeIcon--cc9Nx`,
	"positiveChange": `positiveChange--PNwzf`,
	"negativeChange": `negativeChange--adyfV`,
	"verticalLine": `verticalLine--THTSr`,
	"greenLine": `greenLine--uXkOm`,
	"redLine": `redLine--zEOrT`
};
export default ___CSS_LOADER_EXPORT___;
